import { ReactNode } from 'react'
import { Card } from '@vinted/web-ui'

type Props = {
  children?: ReactNode
}

const Section = ({ children }: Props) => {
  return (
    <Card overflow="unset">
      {/* Note: styling trick to make border radius look correct */}
      <div style={{ padding: '1px' }}>{children}</div>
    </Card>
  )
}

export default Section
